import { gql, useQuery, QueryHookOptions } from "@apollo/client";
import { CANDIDATE_FRAGMENT } from "fragments/candidate";

// Note: These types will be generated when running yarn generate:types
// For now, we define them manually based on the GraphQL schema
export interface SearchCandidatesInput {
  query?: string;
  name?: string;
  company?: string;
  jobTitle?: string;
  education?: string;
  location?: string;
  industry?: string;
  page?: number;
  pageSize?: number;
}

export interface SearchCandidatesResult {
  searchCandidates: {
    candidates: any[];
    total: number;
    page: number;
    pageSize: number;
    hasMore: boolean;
  };
}

export interface SearchCandidatesVariables {
  input: SearchCandidatesInput;
}

export const SEARCH_CANDIDATES = gql`
  ${CANDIDATE_FRAGMENT}
  query SearchCandidates($input: SearchCandidatesInput!) {
    searchCandidates(input: $input) {
      candidates {
        ...CandidateFragment
      }
      total
      page
      pageSize
      hasMore
    }
  }
`;

export const useSearchCandidates = (
  variables: SearchCandidatesVariables,
  options?: QueryHookOptions<SearchCandidatesResult, SearchCandidatesVariables>
) => {
  const res = useQuery<SearchCandidatesResult, SearchCandidatesVariables>(
    SEARCH_CANDIDATES,
    {
      variables,
      ...options,
    }
  );
  return { ...res, data: res.data?.searchCandidates };
};
